/** @format */

import React from 'react';
import {
  Typography,
  Grid,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  CircularProgress,
} from '@mui/material';
import { Icons } from 'components';
import { useCopy } from 'hooks';
import clsx from 'clsx';
import { useStyles } from './style';

const PickList = ({
  title,
  items = [],
  titleProps = {},
  titleRender = (v) => v,
  onRemove = () => { },
  ltr = false,
  labelKey = '',
  loading = false,
  selectedRow = 0,
  enableCopy = false,
  ...rest
}) => {
  const classes = useStyles();
  const { copyItem } = useCopy();

  return (
    <div className={classes.root} {...rest}>
      <Grid container alignItems="center" className={classes.titleBox}>
        <Typography variant="h6" className={classes.title}>
          {title}{' '}
        </Typography>
        <span className={classes.titleArrow}>
          <Icons icon="CaretDown" color="#667585" size="20" />
        </span>
      </Grid>

      <div className={classes.demo}>
        <List dense={false}>
          {items.map((v, k) => (
            <ListItem
              key={k}
              className={clsx(
                k % 2 !== 0 ? 'odd' : '',
                classes.listItem,
                enableCopy ? 'withCopy' : '',
              )}
            >
              <ListItemText
                style={ltr ? { direction: 'ltr', textAlign: 'left' } : {}}
                className={classes.listItemText}
                primary={titleRender(labelKey ? v[labelKey] : v)}
                primaryTypographyProps={{ ...titleProps }}
              />
              <ListItemSecondaryAction>
                {loading && selectedRow === k ? (
                  <CircularProgress color="inherit" size={20} />
                ) : (
                  <>
                    <IconButton
                      onClick={() => onRemove(v, k)}
                      edge="end"
                      aria-label="delete"
                      size="large">
                      <Icons icon="Trash" color="#2b3990" size="18" />
                    </IconButton>
                    {enableCopy ? (
                      <IconButton
                        edge="end"
                        aria-label="copy"
                        onClick={() => copyItem(titleRender(labelKey ? v[labelKey] : v))}
                        size="large">
                        <Icons icon="copy" color="#2b3990" size="18" />
                      </IconButton>
                    ) : null}
                  </>
                )}
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </div>
    </div>
  );
};



export default PickList;
